module.exports = __webpack_public_path__ + "static/img/noticia14.6af2158c.jpg";